module.exports = __webpack_public_path__ + "media/images/country_flags/cv-7852fc0c22577b67d67328bcbbaf3ab3.png";